import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { registerTempUser } from './userThunk';
import { registerTempUserRc } from '../rc/rcThunk';
import { registerTempUserSanteMobilite } from '../sante-mobilite/santeMobiliteThunk';

export interface TempUserInfo {
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  birthdate: string;
  password: string;
  civility: 'M' | 'Mme' | '';
  cguAccepted: boolean;
}

export interface UserState extends TempUserInfo {
  loading: boolean;
  registrationResponse: any | null;
  isTempRegistered: boolean;
}

const initialState: UserState = {
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  birthdate: '',
  password: '',
  civility: '',
  cguAccepted: false,
  loading: false,
  registrationResponse: null,
  isTempRegistered: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setTempUserInfo: (state, action: PayloadAction<Partial<TempUserInfo>>) => {
      return { ...state, ...action.payload };
    },
    resetTempUserInfo: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerTempUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(registerTempUser.fulfilled, (state, action) => {
        state.loading = false;
        state.registrationResponse = action.payload;
        state.isTempRegistered = true;
      })
      .addCase(registerTempUser.rejected, (state) => {
        state.loading = false;
      })
      .addCase(registerTempUserRc.pending, (state) => {
        state.loading = true;
      })
      .addCase(registerTempUserRc.fulfilled, (state, action) => {
        state.loading = false;
        state.registrationResponse = action.payload;
        state.isTempRegistered = true;
      })
      .addCase(registerTempUserRc.rejected, (state) => {
        state.loading = false;
      })
      .addCase(registerTempUserSanteMobilite.pending, (state) => {
        state.loading = true;
      })
      .addCase(registerTempUserSanteMobilite.fulfilled, (state, action) => {
        state.loading = false;
        state.registrationResponse = action.payload;
        state.isTempRegistered = true;
      })
      .addCase(registerTempUserSanteMobilite.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setTempUserInfo, resetTempUserInfo } = userSlice.actions;
export const userReducer = userSlice.reducer;
